class ScrollToBar extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {

    this.announceBarHeight = document.querySelector(`.announcement-bar-section`) ? document.querySelector(`.announcement-bar-section`).clientHeight : 0; // Get the height of the announcement bar
    this.headerHeight = document.querySelector('.section-header') ? document.querySelector('.section-header').clientHeight : 0; // Get the height of the header
    this.barHeight = $(this).height() ? $(this).height() : 0; // Get the height of the bar
    this.headerBarTotalHeight = this.announceBarHeight + this.headerHeight + this.barHeight; // Get the total height of the header and announcement and bar

    this.stbListEle = this.querySelector('.stb__item-list');
    this.listWidth = this.stbListEle.scrollWidth;

    window.addEventListener('scroll', this.onScroll.bind(this));
    window.addEventListener('DOMContentLoaded', this.onDOMContentLoaded.bind(this));
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScroll.bind(this));
    window.removeEventListener('DOMContentLoaded', this.onDOMContentLoaded.bind(this));
  }

  // DOM content loaded event
  onDOMContentLoaded() {
    this.init();

    // Add is-selected class to the first item in the list, if it's not already selected
    let stbFirstItem = this.querySelector('.stb__item-list .stb__item');
    if(stbFirstItem && !stbFirstItem.classList.contains('is-selected')) {
      stbFirstItem.classList.add('is-selected');
      stbFirstItem.parentNode.setAttribute('aria-selected', true);
    }

    if (this.listWidth > window.innerWidth) {
      this.stbItemClick();
    }
  }
  // Init
  init() {
    this.updateListTop();
    this.setupButtons();
    this.initScrollToSection();
    if (this.listWidth > window.innerWidth) {
      this.stbListEle.style.justifyContent = 'flex-start';
    }
  }
  // Update the top position of the bar list
  updateListTop() {
    if (this.stbListEle) {
      this.stbListEle.style.top = `${this.announceBarHeight + this.headerHeight}px`;
    }
  }
  // Update the top position of the bar list when scroll
  scrollUpdateListTop() {
    let tempAnnounceBarH = document.querySelector(`.announcement-bar-section`) ? document.querySelector(`.announcement-bar-section`).clientHeight : 0;
    let tempHeaderH = document.querySelector('.section-header') ? document.querySelector('.section-header').clientHeight : 0;
    if (this.stbListEle && parseInt(this.stbListEle.style.top) != tempAnnounceBarH + tempHeaderH) {
      this.stbListEle.style.top = `${tempAnnounceBarH + tempHeaderH}px`;
    }
  }
  // Set up the click event for the items in the list
  stbItemClick() {
    let items = this.querySelectorAll('.stb__item');
    items.forEach(item => {
      item.addEventListener('click', this.onItemClick.bind(this));
    });
  }
  // Item click event
  onItemClick(e) {
    let id = e.target.getAttribute('data-target-id');
    let element = this.querySelector(`[data-target-id="${id}"]`);
    this.scrollToSelectedItem(element);
  }
  // Scroll Left to the selected item
  scrollToSelectedItem(element) {
    if(element) {
      let elementPosition = element.getBoundingClientRect().left;
      let offsetPosition = elementPosition + this.stbListEle.scrollLeft;
      this.stbListEle.scrollTo({ left: offsetPosition, behavior: 'smooth' });
    }
  }
  // Change the selected status of item in the list
  changeSelected() {
    let sections = document.querySelectorAll('.np-section');
    sections.forEach((section) => {
      let scrollTop = $(window).scrollTop() || document.documentElement.scrollTop;
      let tempDivOffsetTop = section.offsetTop - this.headerBarTotalHeight;
      let tempDivId = section.getAttribute('id');
      if (scrollTop >= tempDivOffsetTop && this.querySelector(`.stb__item[data-target-id='${tempDivId}']`)) {
        let selectedItem = this.querySelector(`.stb__item[data-target-id='${tempDivId}']`);
        $(selectedItem).parent().attr('aria-selected', true).siblings().attr('aria-selected', false);
        $(selectedItem).addClass(`is-selected`).parent().siblings().find(`.stb__item`).removeClass(`is-selected`);
        this.scrollToSelectedItem(selectedItem);
      }
    });
  }
  // Sticky Bar
  stickyBar() {
    let scrollTop = $(window).scrollTop() || document.documentElement.scrollTop;
    let divOffsetTop = this.offsetTop - this.announceBarHeight - this.headerHeight;
    if (scrollTop >= divOffsetTop) {
      this.stbListEle.style.position = 'fixed';
    } else {
      this.stbListEle.style.position = 'static';
    }
  }
  // Scroll event
  onScroll() {
    this.stickyBar();
    this.scrollUpdateListTop();
    this.changeSelected();
  }
  // Set up the click event for the bar tab buttons
  setupButtons() {
    let stbButtons = this.querySelectorAll('.stb__item');
    stbButtons.forEach((el) => {
      let targetId = el.getAttribute('data-target-id');
      if (!document.getElementById(targetId)) {
        el.remove();
      } else {
        el.addEventListener('click', this.onButtonClick.bind(this, targetId));
      }
    });
  }
  // Bar tab button click event
  onButtonClick(targetId, event) {
    event.preventDefault();
    let element = document.getElementById(targetId);
    if (element) {
      let elementPosition = element.getBoundingClientRect().top;
      let offsetPosition = elementPosition + $(window).scrollTop() - this.headerBarTotalHeight + 10;
      window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
    }
  }
  // Auto scroll to the section when the URL with hash default
  initScrollToSection() {
    let element = window.location.hash ? document.querySelector(window.location.hash) : null;
    if (element) {
      let elementPosition = element.getBoundingClientRect().top;
      let offsetPosition = elementPosition + $(window).scrollTop() - this.headerBarTotalHeight + 10;
      window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
    }
  }
}

// Define custom element
customElements.define('scroll-to-bar', ScrollToBar);
